export default __webpack_public_path__ + "static/media/Savant's Gloves of the Crescent.ff5ba2c7.jpg";